export default "__VITE_ASSET__COm4qHx6__"